export default __webpack_public_path__ + "static/media/Content1.2833af6f.png";